import { KPIMetricsContainer } from './kpi-metrics-container';

export const SalesDashboard = () => {
  return <KPIMetricsContainer />;
};
